import { type MoneyAmount } from 'types'
import { getMinifiedLocaleCurrencyStringFromMoneyAmount } from 'utils'

import { useCardPayment } from '../payments/CardPaymentProvider'

type Props = {
  balance: MoneyAmount;
  remainingBalance: number;
}

export const balanceDescription = (balance: MoneyAmount, remainingBalance: number, cardPaymentsEnabled?: boolean) => {
  if (remainingBalance >= 0) {
    return 'Your balance covers the full cost.'
  }

  if (!cardPaymentsEnabled) {
    return 'You do not have enough balance for this purchase.'
  }

  if (parseFloat(balance.value) === 0) {
    return 'No remaining balance available. The entire amount needs to be charged to your personal card.'
  }

  return 'Your balance is applied toward the full cost. The remaining amount needs to be charged to your personal card.'
}

export const Balance = ({ balance, remainingBalance }: Props) => {
  const { cardPaymentsEnabled } = useCardPayment()

  return (
    <div className='flex flex-col gap-1'>
      <div className='flex flex-row justify-between gap-2'>
        <span className='body-bold'>Thatch balance</span>
        <span className='body-bold'>{getMinifiedLocaleCurrencyStringFromMoneyAmount(balance)}</span>
      </div>
      <p className='body-sm text-gray-500 w-4/5'>
        {balanceDescription(balance, remainingBalance, cardPaymentsEnabled)}
      </p>
    </div>
  )
}
